import React from "react";
import { Card, CardBody, Row, Table } from "reactstrap";
import Skeleton from "react-loading-skeleton";

const LeadSubSectionLoading = () => {

    return (
        <React.Fragment>
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td><Skeleton /></td>
                                        <td><Skeleton /></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                        <td style={{ width: '33%' }}>
                                            <Skeleton />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadSubSectionLoading